import {
  GameCommunicationTimerProcessor,
  GameCommunicationMessageType,
  GameCommunicationSenderType,
  GameCommunicationMetaType,
  CoreStoreType,
  betActions,
  BetType,
  popupActions,
  PopupType,
  countTotalBet,
  autoplayActions,
  Logger,
  toastActions,
  UserInfoType,
  CurrencyInfo,
} from '@pp/core';
import { GameInstantBetsSender } from '../senders/GameInstantBetSender';
import { mwStateActions } from '../../../store/slices/mwState/slice';

export interface TimerMessage extends GameCommunicationMessageType {
  value: string;
}
const senders = new GameInstantBetsSender();

export class MwCommunicationTimerProcessor extends GameCommunicationTimerProcessor {
  process(
    message: TimerMessage,
    store: CoreStoreType,
    sender: GameCommunicationSenderType,
    meta: GameCommunicationMetaType
  ): void {
    const { connectionProcedure } = meta;
    connectionProcedure();

    const value = Number(message.value) - message.delay / 1000;
    store.dispatch(betActions.resetBetStack());
    if (value > 0) {
      this.checkAndPlaceAutoplayAvailability(store);
    }
    store.dispatch(mwStateActions.resetForNewGame());
    super.process(message, store, sender, meta);
  }

  protected checkAndPlaceAutoplayAvailability(store: CoreStoreType): void {
    const state = store.getState();
    const { isInProgress, savedBet } = state.autoplay;
    const { userInfo, currencyInfo } = state.gameState;
    const disabledBets = state.bets.disabledBetSpots || [];

    if (isInProgress) {
      this.checkAutoplayAvailability(store, userInfo, currencyInfo, savedBet, disabledBets);
      this.placeAutoplayBet(store, userInfo, currencyInfo, savedBet, disabledBets);
    }
  }

  protected placeAutoplayBet(
    store: CoreStoreType,
    userInfo: UserInfoType | null,
    currencyInfo: CurrencyInfo | null,
    savedBet: BetType | null,
    disabledBetSpots: string[]
  ): void {
    const deductibleBalance = (userInfo?.balance.amount || 0) + (userInfo?.balance.bonus || 0);
    const newBet: BetType = { betSpots: {} };

    for (const betId in savedBet?.betSpots) {
      const betSpotValue = savedBet.betSpots[betId].value > 0 && !disabledBetSpots.includes(betId);
      if (betSpotValue) {
        newBet.betSpots[betId] = savedBet.betSpots[betId];
      }
    }

    store.dispatch(
      betActions.pushBet({
        bet: newBet,
        balance: deductibleBalance,
        decimals: currencyInfo?.digitsNumber || 2,
      })
    );
    senders.dispatch('');
    store.dispatch(popupActions.dismissPopup(PopupType.AutoplayModified));
  }

  protected checkAutoplayAvailability(
    store: CoreStoreType,
    userInfo: UserInfoType | null,
    currencyInfo: CurrencyInfo | null,
    savedBet: BetType | null,
    disabledBetSpots: string[]
  ) {
    const totalBet = countTotalBet(savedBet?.betSpots || {}, currencyInfo?.digitsNumber || 0);
    const betSpots = Object.keys(savedBet?.betSpots || {}).filter((el) => (savedBet?.betSpots?.[el]?.value || 0) > 0);
    const betUnavailable = betSpots.some((r) => disabledBetSpots.includes(r));

    if (betUnavailable || totalBet > (userInfo?.balance.amount || 0)) {
      let toastKey = '';
      let logReason = '';
      if (betUnavailable) {
        toastKey = 'AUTOPLAY_PREFERENCES_STOPPED';
        logReason = 'BetsUnavailable';
      } else {
        toastKey = 'AUTOPLAY_SUPPORT_CURR_BAL';
        logReason = 'NoMoney';
      }
      store.dispatch(autoplayActions.stop());
      store.dispatch(toastActions.createToast(toastKey));
      Logger.logEvent('click', 'autoplay_stop', Date.now(), 1, logReason, false);
    }
  }
}
